import { DeleteApiClient, GetApiClient, PostApiClient } from "@/utils/api-client";
import { DataSchema } from "common";

type GetBookmarksResponse = DataSchema.BookmarkList;
export const getBookmarksApi = (apiClient: GetApiClient) => {
  return apiClient.get<GetBookmarksResponse>("/api/bookmarks");
};

type PostBookmarkRequest = DataSchema.Bookmark;
export const postBookmarkApi = (apiClient: PostApiClient, data: PostBookmarkRequest) => {
  return apiClient.post("/api/bookmarks", {
    body: JSON.stringify(data),
  });
};

export const deleteBookmarkApi = (apiClient: DeleteApiClient, documentId: string, pageNo: number) => {
  return apiClient.del(`/api/bookmarks/${encodeURIComponent(documentId)}/${pageNo}`);
};
